import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { naira, waLink } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export const OrderSuccess = ({ order }) => {
  const { settings } = useStore();
  const msg = `Hi 17/11 BeautyBarn! I just placed order #${order.orderNumber} for ${naira(
    order.total
  )}. Please confirm my order. Thank you!`;

  return (
    <div className="pt-32 md:pt-40 pb-24 min-h-screen" data-testid="order-success">
      <div className="max-w-xl mx-auto px-5 text-center">
        <motion.div
          initial={{ scale: 0, rotate: -20 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: "spring", stiffness: 200, damping: 15 }}
          className="inline-flex mb-6"
        >
          <CheckCircle2 className="w-16 h-16 text-moss" strokeWidth={1.4} />
        </motion.div>
        <p className="overline text-terracotta mb-3">Order confirmed</p>
        <h1 className="font-serif text-4xl md:text-5xl text-espresso tracking-tight mb-4">Thank you for your order!</h1>
        <p className="text-bark mb-2">
          Your order number is <span className="text-espresso font-semibold" data-testid="success-order-number">#{order.orderNumber}</span>
        </p>
        <p className="text-bark mb-8">
          Total paid: <span className="text-espresso font-semibold">{naira(order.total)}</span>
        </p>

        <div className="bg-sand rounded-2xl p-6 text-left mb-8">
          <p className="text-espresso font-medium mb-1">One quick step</p>
          <p className="text-bark text-sm">
            Confirm your order on WhatsApp so we can arrange your delivery and share updates directly with you.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={waLink(settings.whatsapp, msg)}
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-confirm-button"
            className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white px-7 py-3.5 rounded-full font-medium hover:opacity-90 transition-opacity"
          >
            Confirm on WhatsApp
          </a>
          <Link
            to="/shop"
            className="inline-flex items-center justify-center gap-2 border border-sandline text-espresso px-7 py-3.5 rounded-full font-medium hover:bg-sand transition-colors"
            data-testid="success-continue-shopping"
          >
            Continue shopping <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <Link to="/track" className="inline-block mt-6 text-bark hover:text-terracotta text-sm underline">
          Track your order
        </Link>
      </div>
    </div>
  );
};
